import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    if (this.element.tomselect) return;

    this.tomSelect = new TomSelect(this.element, {
      create: false,
      hideSelected: true,
      maxOptions: 5000,
      plugins: {
        checkbox_options: {
          checkedClassNames: ["ts-checked"],
          uncheckedClassNames: ["ts-unchecked"]
        }
      },
      sortField: {
        field: "text",
        direction: "asc"
      },
      onChange: () => {
        if (this.element.getAttribute("multiple") === "multiple") return;

        this.tomSelect.close();
        this.tomSelect.blur();
      }
    });
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }

    if (this.element.tomselect) {
      this.element.tomselect = null;
    }

    this.tomSelect = null;
  }
}
